module.exports = __webpack_public_path__ + "static/media/a-112-02.0adaa7bb.webp";